import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram } from 'react-icons/fa';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.tribalBorder}></div>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <h3 className={styles.footerTitle}>
            <span className="gujarati-text">બાહરીયા ફાર્મ</span>
          </h3>
          <p className={styles.footerDesc}>
            Pure Gir Cow Bilona Ghee<br />
            <span className="gujarati-text">શુદ્ધ ગીર ગાયનું બિલોણા ઘી</span>
          </p>
          <div className={styles.socialLinks}>
            <a href="https://www.instagram.com/bahariyafood_llp/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
          </div>
        </div>

        <div className={styles.footerSection}>
          <h4>Quick Links</h4>
          <ul className={styles.footerLinks}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/process">Our Process</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h4>Our Promise</h4>
          <ul className={styles.footerFeatures}>
            <li>✓ 100% Natural</li>
            <li>✓ Chemical Free</li>
            <li>✓ Protein</li>
            <li>✓ Hand-Churned</li>
            <li>✓ Farm Fresh</li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h4>Contact Us</h4>
          <p className={styles.contactInfo}>
            📍 JAY SHREE FARM HOUSE, <br /> OPP - MARKETING YARD, <br />SHITAL PARK - 1, <br /> OPP - SURUCHI SCHOOL, <br />KHAPAT, PORBANDAR - GUJARAT - 360575<br />
            📞 +91 90990 99901<br />
            ✉️ bahariyafood91@yahoo.com
          </p>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p>&copy; 2026 BAHARIYA FARM - PORBANDAR. All Rights Reserved.</p>
        <p className={styles.tagline}>
          <span className="gujarati-text">પરંપરામાં મૂળ, વિશ્વાસ સાથે વિતરિત</span>
        </p>
        <p className={styles.developer}>
          Developed by <a href="https://triklabs.com" target="_blank" rel="noopener noreferrer">Triklabs</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
